import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import clsx from 'clsx'
import Image from '@v4/components/common/Image'
import ItemBorder from '@v4/components/common/ItemBorder'
import { useItem } from './Item.hooks'

const Item = props => {
	const [{ classes, columnsNumber, imageData, itemKey }, { handleImageClick }] = useItem(props)

	return (
		<Grid
			item
			lg={columnsNumber === 5 || 12 / columnsNumber}
			md={columnsNumber > 4 ? 3 : 12 / columnsNumber}
			sm={columnsNumber > 3 ? 4 : 12 / columnsNumber}
			xs={columnsNumber >= 2 ? 6 : 12}
			className={clsx(classes.root, { [classes.fiveColumns]: columnsNumber === 5 }, 'content4-item')}
		>
			<ItemBorder itemKey={itemKey} group="items">
				<Image
					className={clsx(classes.image, 'content4-item-image')}
					metaData={imageData}
					onClick={handleImageClick}
				/>
			</ItemBorder>
		</Grid>
	)
}

Item.propTypes = {
	verticalAlignment: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	columnsNumber: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
}

Item.defaultProps = {
	verticalAlignment: 'flex-start',
}

export default memo(Item)
